import { useEffect } from "react";
import { updatePageSEO } from "@/lib/seo";

const TermsOfService = () => {
  useEffect(() => {
    updatePageSEO({
      title: "Terms of Service | Diane Corso Fiction",
      description: "Terms of service for www.dianecorsofiction.com — the rules and guidelines for using Diane Corso's author website.",
      canonical: "https://www.dianecorsofiction.com/terms",
      ogImage: "https://www.dianecorsofiction.com/attached_assets/broken things book rev (1)_1756509124921.webp",
    });
  }, []);

  return (
    <div className="min-h-screen pt-16">
      <section className="py-20 bg-gothic-black">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h1 className="text-4xl font-cinzel font-bold text-blood-red mb-4">Terms of Service</h1>
            <p className="text-gray-400">Last updated: {new Date().toLocaleDateString()}</p>
          </div>

          <div className="prose prose-lg max-w-none text-gray-300">
            <h2 className="text-2xl font-playfair font-bold text-gothic-white mb-4">Acceptance of Terms</h2>
            <p className="mb-6">
              By accessing and using Diane Corso's website (the "Service"), you accept and agree to be bound by the terms and provision of this agreement. If you do not agree to these terms, you should not access or use the Service.
            </p>

            <h2 className="text-2xl font-playfair font-bold text-gothic-white mb-4 mt-8">Use License</h2>
            <p className="mb-6">
              Permission is granted to temporarily download one copy of the materials on Diane Corso's website for personal, non-commercial transitory viewing only. This is the grant of a license, not a transfer of title, and under this license you may not:
            </p>
            <ul className="list-disc pl-6 mb-6 space-y-2">
              <li>Modify or copy the materials</li>
              <li>Use the materials for any commercial purpose or for any public display</li>
              <li>Attempt to reverse engineer any software contained on the website</li>
              <li>Remove any copyright or other proprietary notations from the materials</li>
            </ul>

            <h2 className="text-2xl font-playfair font-bold text-gothic-white mb-4 mt-8">Copyright and Intellectual Property</h2>
            <p className="mb-6">
              All content on this website, including but not limited to text, graphics, logos, images, and software, is the property of Diane Corso or her content suppliers and is protected by international copyright laws. The compilation of all content on this site is the exclusive property of Diane Corso.
            </p>

            <h2 className="text-2xl font-playfair font-bold text-gothic-white mb-4 mt-8">User Content</h2>
            <p className="mb-6">
              When you submit content through our contact forms, newsletter subscriptions, or other interactive features, you grant Diane Corso a non-exclusive, royalty-free license to use, reproduce, and distribute such content for the purposes of providing our services.
            </p>

            <h2 className="text-2xl font-playfair font-bold text-gothic-white mb-4 mt-8">Disclaimer</h2>
            <p className="mb-6">
              The materials on Diane Corso's website are provided on an 'as is' basis. Diane Corso makes no warranties, expressed or implied, and hereby disclaims and negates all other warranties including without limitation, implied warranties or conditions of merchantability, fitness for a particular purpose, or non-infringement of intellectual property or other violation of rights.
            </p>

            <h2 className="text-2xl font-playfair font-bold text-gothic-white mb-4 mt-8">Limitations</h2>
            <p className="mb-6">
              In no event shall Diane Corso or her suppliers be liable for any damages (including, without limitation, damages for loss of data or profit, or due to business interruption) arising out of the use or inability to use the materials on Diane Corso's website, even if Diane Corso or her authorized representative has been notified orally or in writing of the possibility of such damage.
            </p>

            <h2 className="text-2xl font-playfair font-bold text-gothic-white mb-4 mt-8">External Links</h2>
            <p className="mb-6">
              This website may contain links to external sites. Diane Corso has not reviewed all of the sites linked to and is not responsible for the contents of any such linked site. The inclusion of any link does not imply endorsement by Diane Corso of the site.
            </p>

            <h2 className="text-2xl font-playfair font-bold text-gothic-white mb-4 mt-8">Modifications</h2>
            <p className="mb-6">
              Diane Corso may revise these terms of service at any time without notice. By using this website, you are agreeing to be bound by the then current version of these terms of service.
            </p>

            <h2 className="text-2xl font-playfair font-bold text-gothic-white mb-4 mt-8">Governing Law</h2>
            <p className="mb-6">
              These terms and conditions are governed by and construed in accordance with the laws of the United States and you irrevocably submit to the exclusive jurisdiction of the courts in that state or location.
            </p>

            <h2 className="text-2xl font-playfair font-bold text-gothic-white mb-4 mt-8">Contact Information</h2>
            <p className="mb-6">
              If you have any questions about these Terms of Service, please contact us at:
            </p>
            <p className="mb-4">
              Email: legal@dianecorso.com<br />
              Or use our <a href="/contact" className="text-blood-red hover:text-gothic-white">contact form</a>
            </p>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TermsOfService;
